import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookmarkPlus, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { errMsg } from "@/lib/api";

export default function TemplateBar({ content, imageId, onApply, initialId }) {
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/templates").then((r) => {
      setTemplates(r.data);
      const t = initialId && r.data.find((x) => x.id === initialId);
      if (t) onApply(t);
    }).catch(() => {});
  }, [initialId]); // eslint-disable-line react-hooks/exhaustive-deps

  const apply = (id) => {
    const t = templates.find((x) => x.id === id);
    if (t) { onApply(t); toast.success(`Template "${t.name}" digunakan`); }
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/templates", { name, content, image_id: imageId });
      setTemplates([data, ...templates]);
      toast.success("Template disimpan");
      setOpen(false);
      setName("");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <>
      <Select value="" onValueChange={apply}>
        <SelectTrigger className="h-9 w-48 bg-background text-sm" data-testid="composer-template-select">
          <SelectValue placeholder={templates.length ? "Guna template..." : "Tiada template"} />
        </SelectTrigger>
        <SelectContent>
          {templates.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`composer-template-option-${t.id}`}>{t.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button type="button" variant="ghost" size="sm" disabled={!content.trim()} onClick={() => setOpen(true)} data-testid="composer-save-template-btn">
        <BookmarkPlus className="mr-1.5 h-3.5 w-3.5" /> Simpan template
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-border bg-card" data-testid="save-template-dialog">
          <DialogHeader>
            <DialogTitle>Simpan sebagai template</DialogTitle>
            <DialogDescription>Teks dan gambar semasa akan disimpan untuk diguna semula.</DialogDescription>
          </DialogHeader>
          <form onSubmit={save} className="space-y-4">
            <Input required value={name} onChange={(e) => setName(e.target.value)} placeholder="cth: Promosi hujung minggu" data-testid="save-template-name-input" />
            <Button type="submit" disabled={busy} className="w-full" data-testid="save-template-submit-btn">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Simpan
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
